import React from 'react';
import PropTypes from 'prop-types';
import StudentChurnSummary from './StudentChurnSummary';
import { toJS } from 'mobx';
import { StudentChurnListService } from '../../services/CustomerSuccessKpiListService';
import { observer } from 'mobx-react';
import { get } from 'lodash';

class StudentChurnSummaryContainer extends React.Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    typeId: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    StudentChurnListService.load();
  }

  render() {
    const data = toJS(StudentChurnListService.getSummaryByType(this.props.type, this.props.typeId));
    return (
      <StudentChurnSummary
        isLoading={StudentChurnListService.fetchCurrent.fetching || StudentChurnListService.fetchPrevious.fetching}
        currentValue={get(data, 'current')}
        previousValue={get(data, 'previous')}
        standardDeviationValue={get(data, 'currentStandardDeviation')}
        formatter={StudentChurnListService.getFormattedValue}
      />
    );
  }
}

export default observer(StudentChurnSummaryContainer);
